import EnhancedLocalStorageService from "./enhanced/EnhancedLocalStorage";
import EnhancedProductService from "./enhanced/EnhancedProductService";
import CompatibleProductsService from "./CompatibleProductsService";

const productPageMountedLogic = (
  store,
  seriesId,
  skuId,
  isPageEnhanced,
  variantCode,
  enhancedSeriesId,
  requestReferer
) => {
  if (isPageEnhanced) {
    store
      .dispatch("user/loadProductUser")
      // then sets the series id
      .then(() => {
        let localState = EnhancedLocalStorageService.getEnhancedLocalStorage(
          "legrandAv_enhancedLocalStorageState"
        );
        if (
          localState &&
          Object.keys(localState).length > 0 &&
          (requestReferer.includes("login") ||
            requestReferer.includes("accountselection") ||
            requestReferer.includes("products"))
        ) {
          // Restore Enhanced Product data from Local Storage
          if (localState.enhancedproduct) {
            // restore the vue state from local stoage is exists
            var MvcSkeleton = document.getElementById("MvcSkeleton");
            if (MvcSkeleton) {
              MvcSkeleton.setAttribute("style", "display: none");
            }

            store
              .dispatch(
                "enhancedproduct/restoreStateFromLocalStorage",
                localState.enhancedproduct
              )
              .then(() => {
                let _tmpSections = JSON.parse(
                  JSON.stringify(localState.enhancedproduct.sections)
                );
                let sectionIdToMakePricingCall = null;
                // loop through the sections array and break the loop at !isComplete
                for (let key in _tmpSections) {
                  if (_tmpSections[key] && !_tmpSections[key].isComplete) {
                    sectionIdToMakePricingCall = key;
                    break;
                  }
                }
                // Update the product options with pricing
                if (sectionIdToMakePricingCall) {
                  store.dispatch(
                    "enhancedproduct/updatedSectionEnhancedProductOptionValues",
                    {
                      SectionId: sectionIdToMakePricingCall,
                      VariantCode: localState.enhancedproduct.variantCode
                    }
                  );
                }

                // Clear local storage after the vue state is restored from local storage
                EnhancedLocalStorageService.setEnhancedLocalStorage({});
              });
          }

          // Restore BOM from Local Storage
          if (localState.enhancedBom) {
            var wecoUser = JSON.parse(getCookie("WECO_user"));
            let customerNumber = wecoUser.CUST_NUMBER;
            let salesOrg = wecoUser.SALESORG;
            let productIds = [];
            let productVarIds = [];
            if (
              localState.enhancedBom &&
              localState.enhancedBom.billOfMaterials &&
              localState.enhancedBom.billOfMaterials.BOM
            ) {
              localState.enhancedBom.billOfMaterials.BOM.map(bom => {
                if (!bom.IsProductVariant) {
                  productIds.push(bom.PartName.trim());
                } else if (
                  bom.IsProductVariant &&
                  (bom.PartName.slice(0, 3) === "C3K" ||
                    bom.PartName.slice(0, 3) === "L5K" ||
                    bom.PartName.slice(0, 3) === "C5K")
                ) {
                  productVarIds.push(bom.PartName.trim());
                } else if (bom.IsProductVariant) {
                  if (bom.PartName.slice(0, 2) === "FM") {
                    productIds.push(bom.PartName.trim());
                  } else {
                    productIds.push(bom.PartName.trim().substring(0, 9));
                  }
                  productVarIds.push(bom.PartName.trim());
                }
              });
            }

            if (
              localState.enhancedBom &&
              localState.enhancedBom.billOfMaterialsParts
            ) {
              for (let key in localState.enhancedBom.billOfMaterialsParts) {
                productIds.push(
                  localState.enhancedBom.billOfMaterialsParts[key].Value.trim()
                );
              }
              // Load compatible products section when no BOM
              if (localState.enhancedBom.billOfMaterials.BOM.length == 0) {
                CompatibleProductsService.showCompatibleProducts(true);
              }
            }

            EnhancedProductService.fetchPricingForBillOFMaterial(
              productVarIds,
              customerNumber,
              salesOrg,
              true
            ).then(response => {
              if (response.data.length) {
                for (let i = 0; i < response.data.length; i++) {
                  for (
                    let j = 0;
                    j < localState.enhancedBom.billOfMaterials.BOM.length;
                    j++
                  ) {
                    if (
                      localState.enhancedBom.billOfMaterials.BOM[j]
                        .IsProductVariant &&
                      localState.enhancedBom.billOfMaterials.BOM[
                        j
                      ].PartName.slice(0, 3) ===
                        response.data[i].ProductId.slice(0, 3)
                    ) {
                      localState.enhancedBom.billOfMaterials.BOM[j].Price =
                        response.data[i];
                    }
                  }
                }
              } else {
                for (
                  let j = 0;
                  j < localState.enhancedBom.billOfMaterials.BOM.length;
                  j++
                ) {
                  if (
                    localState.enhancedBom.billOfMaterials.BOM[j]
                      .IsProductVariant &&
                    localState.enhancedBom.billOfMaterials.BOM[
                      j
                    ].PartName.slice(0, 3) ===
                      response.data.ProductId.slice(0, 3)
                  ) {
                    localState.enhancedBom.billOfMaterials.BOM[j].Price =
                      response.data;
                  }
                }
              }
            });

            EnhancedProductService.fetchPricingForBillOFMaterial(
              productIds,
              customerNumber,
              salesOrg,
              true
            )
              .then(response => {
                for (let i = 0; i < response.data.length; i++) {
                  for (
                    let j = 0;
                    j < localState.enhancedBom.billOfMaterials.BOM.length;
                    j++
                  ) {
                    if (
                      !localState.enhancedBom.billOfMaterials.BOM[j]
                        .IsProductVariant &&
                      localState.enhancedBom.billOfMaterials.BOM[j].PartName ===
                        response.data[i].ProductId
                    ) {
                      localState.enhancedBom.billOfMaterials.BOM[j].Price =
                        response.data[i];
                    }
                    if (
                      localState.enhancedBom.billOfMaterials.BOM[j]
                        .IsProductVariant &&
                      localState.enhancedBom.billOfMaterials.BOM[
                        j
                      ].PartName.substring(0, 9) === response.data[i].ProductId
                    ) {
                      localState.enhancedBom.billOfMaterials.BOM[j].Price =
                        response.data[i];
                    }

                    for (let key in localState.enhancedBom
                      .billOfMaterialsParts) {
                      if (
                        localState.enhancedBom.billOfMaterialsParts[key]
                          .Value === response.data[i].ProductId
                      ) {
                        localState.enhancedBom.billOfMaterialsParts[key].Price =
                          response.data[i];
                      }
                    }
                  }
                }
              })
              .then(() => {
                store.dispatch(
                  "enhancedBom/restoreBomFromLocalStorage",
                  localState.enhancedBom
                );
              })
              .then(() => {
                if (
                  localState.enhancedBom &&
                  localState.enhancedBom.billOfMaterials &&
                  localState.enhancedBom.billOfMaterials.BOM
                ) {
                  const sku = localState.enhancedBom.billOfMaterials.BOM.filter(
                    d => d.IsPrimaryPart
                  );

                  //To clear the compatible products
                  CompatibleProductsService.fireProductLoadedEvent(null);

                  if (sku && sku[0]) {
                    //This to load the compatible products
                    CompatibleProductsService.fireProductLoadedEvent(sku[0]);
                    CompatibleProductsService.showCompatibleProducts(true);
                  }
                }
              });
          }

          // Restore specs from Local Storage
          if (localState.prodspecification) {
            store.dispatch(
              "prodspecification/restoreStateFromLocalStorage",
              localState.prodspecification
            );
          }

          if (localState.resource) {
            store.dispatch(
              "resource/restoreStateFromLocalStorage",
              localState.resource
            );
          }
        } else {
          store.dispatch("enhancedproduct/setSeriesId", {
            seriesId: seriesId
          });
          store.dispatch("enhancedproduct/setEnhancedSeriesId", {
            enhancedSeriesId: enhancedSeriesId
          });
          store.dispatch("enhancedproduct/setVariantCode", {
            variantCode: variantCode
          });
          store.dispatch("enhancedproduct/setIsEnhancedPDP", {
            isPageEnhanced
          });
          store.dispatch("enhancedproduct/loadEnhancedProductData", {
            seriesId,
            skuId
          });
          store.dispatch(
            "enhancedproduct/updatedSectionEnhancedProductOptionValues",
            {
              SectionId: "1",
              VariantCode: variantCode
            }
          );
        }
        store.dispatch("resources/loadProductResource", {
          seriesId,
          skuId
        });
      });
  } else {
    // gets the user
    store
      .dispatch("user/loadProductUser")
      // then sets the series id
      .then(() => {
        store
          .dispatch("product/setSeriesId", { seriesId })
          // then loads our product
          .then(() => {
            store
              .dispatch("product/loadProduct", {
                seriesId,
                skuId,
                useOptimProduct: true
              })
              // then gets our product specifications
              .then(() => {
                store.dispatch("prodspecification/loadProductSpecification", {
                  seriesId,
                  skuId
                });
                store.dispatch("resources/loadProductResource", {
                  seriesId,
                  skuId
                });
                store.dispatch("product/loadProductPrice", { store });
              });
          });
      });
  }
};

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export default {
  productPageMountedLogic
};
